// ==========================================================
// HERO.jsx
// HOTEL ORION GUAJIRA
// HERO PREMIUM HOTEL
// ==========================================================

import { useEffect, useState } from "react";
import "../styles/main.css";

export default function Hero() {
  const [hero, setHero] = useState(null);
  const [loading, setLoading] = useState(true);

  // ==========================================================
  // LOAD HERO
  // ==========================================================

  useEffect(() => {
    const loadHero = async () => {
      try {
        const res = await fetch(
          "https://hotelorionmayapo.com/api/content/hero"
        );

        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }

        const data = await res.json();

        setHero(data);
      } catch (error) {
        console.error(
          "Error loading hotel hero:",
          error
        );
      } finally {
        setLoading(false);
      }
    };

    loadHero();
  }, []);

  // ==========================================================
  // LOADING
  // ==========================================================

  if (loading) {
    return (
      <section className="hero hero--loading">
        <div className="hero__loading">

          <div className="hero__spinner"></div>

          <p>
            Cargando experiencia...
          </p>

        </div>
      </section>
    );
  }

  // ==========================================================
  // FALLBACK
  // ==========================================================

  if (!hero) {
    return (
      <section className="hero hero--loading">
        <div className="hero__loading">

          <p>
            Descubre Hotel Orión Guajira.
          </p>

        </div>
      </section>
    );
  }

  // ==========================================================
  // CONTENT
  // ==========================================================

  const content =
    hero.content || {};

  // ==========================================================
  // HERO IMAGE
  // ==========================================================

  const image =
    hero.images?.find(
      (img) => img.type === "hero"
    )?.url ||
    "/images/hero.png";

  // ==========================================================
  // HOTEL CONTENT
  // ==========================================================

  const badge =
    content.badge ||
    "HOTEL ORIÓN • GUAJIRA";

  const title =
    content.title ||
    "Descanso frente al";

  const subtitle =
    content.subtitle ||
    "paraíso";

  const description =
    content.description ||
    "Vive una experiencia única en La Guajira. Confort, naturaleza y hospitalidad en un solo lugar.";

  // ==========================================================
  // WHATSAPP
  // ==========================================================

  const phone =
    content.phone ||
    "573104794943";

  const whatsappText =
    content.whatsapp_text ||
    "Hola, quiero reservar una habitación en Hotel Orión Guajira.";

  const whatsappMessage =
    encodeURIComponent(
      whatsappText
    );

  const whatsappUrl =
    `https://wa.me/${phone}?text=${whatsappMessage}`;

  // ==========================================================
  // ACTIONS
  // ==========================================================

  const primaryButton =
    content.primary_button ||
    "Reservar Ahora";

  const secondaryButton =
    content.secondary_button ||
    "Ver Habitaciones";

  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <section
      id="hero"
      className="hero hero--hotel"
    >

      {/* ======================================================
          BACKGROUND
      ====================================================== */}

      <div className="hero__background">

        <img
          src={image}
          alt="Hotel Orión Guajira"
          className="hero__background-image"
        />

        <div
          className="hero__background-overlay"
        />

        <div
          className="hero__background-gradient"
        />

      </div>


      {/* ======================================================
          DECORATIVE ELEMENTS
      ====================================================== */}

      <div
        className="hero__ambient hero__ambient--one"
      />

      <div
        className="hero__ambient hero__ambient--two"
      />


      {/* ======================================================
          MAIN CONTENT
      ====================================================== */}

      <div className="hero__container">

        {/* ====================================================
            LEFT CONTENT
        ==================================================== */}

        <div className="hero__content">

          {/* ==================================================
              BADGE
          ================================================== */}

          <div className="hero__badge">

            <span className="hero__badge-line" />

            <span>
              {badge}
            </span>

          </div>


          {/* ==================================================
              TITLE
          ================================================== */}

          <h1 className="hero__title">

            <span>
              {title}
            </span>

            <em>
              {subtitle}
            </em>

          </h1>


          {/* ==================================================
              DESCRIPTION
          ================================================== */}

          <p className="hero__description">
            {description}
          </p>


          {/* ==================================================
              ACTIONS
          ================================================== */}

          <div className="hero__actions">

            {/* ================================================
                PRIMARY · WHATSAPP
            ================================================ */}

            <a
              href={whatsappUrl}
              className="hero__button hero__button--primary"
              target="_blank"
              rel="noopener noreferrer"
            >

              <span>
                {primaryButton}
              </span>

              <span className="hero__button-icon">
                →
              </span>

            </a>


            {/* ================================================
                SECONDARY · ROOMS
            ================================================ */}

            <a
              href="#habitaciones"
              className="hero__button hero__button--secondary"
            >

              <span>
                {secondaryButton}
              </span>

              <span>
                ↓
              </span>

            </a>

          </div>

        </div>

      </div>


      {/* ======================================================
          HOTEL BENEFITS
      ====================================================== */}

      <div className="hero__benefits">

        {/* ====================================================
            BENEFIT 1
        ==================================================== */}

        <div className="hero__benefit">

          <div className="hero__benefit-icon">
            ♧
          </div>

          <div>

            <strong>
              Ubicación privilegiada
            </strong>

            <span>
              Frente al mar, en el corazón
              de La Guajira.
            </span>

          </div>

        </div>


        {/* ====================================================
            BENEFIT 2
        ==================================================== */}

        <div className="hero__benefit">

          <div className="hero__benefit-icon">
            ♢
          </div>

          <div>

            <strong>
              Comodidad
            </strong>

            <span>
              Habitaciones modernas
              y acogedoras.
            </span>

          </div>

        </div>


        {/* ====================================================
            BENEFIT 3
        ==================================================== */}

        <div className="hero__benefit">

          <div className="hero__benefit-icon">
            ✧
          </div>

          <div>

            <strong>
              Mejor precio
            </strong>

            <span>
              Tarifas justas y sin
              cargos ocultos.
            </span>

          </div>

        </div>


        {/* ====================================================
            BENEFIT 4
        ==================================================== */}

        <div className="hero__benefit">

          <div className="hero__benefit-icon">
            ♡
          </div>

          <div>

            <strong>
              Atención 24/7
            </strong>

            <span>
              Estamos siempre listos
              para atenderte.
            </span>

          </div>

        </div>

      </div>


      {/* ======================================================
          SCROLL INDICATOR
      ====================================================== */}

      <a
        href="#habitaciones"
        className="hero__scroll"
        aria-label="Ver habitaciones"
      >

        <span>
          DESCUBRE
        </span>

        <i>
          ↓
        </i>

      </a>


      {/* ======================================================
          WHATSAPP FLOATING BUTTON
      ====================================================== */}

      <a
        href={whatsappUrl}
        className="hero__whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Reservar por WhatsApp"
      >

        <svg
          viewBox="0 0 32 32"
          aria-hidden="true"
        >

          <path
            d="M16 3C8.82 3 3 8.72 3 15.78c0 2.53.75 4.88 2.04 6.86L3.2 29l6.55-1.78A13.03 13.03 0 0 0 16 28.56c7.18 0 13-5.72 13-12.78S23.18 3 16 3Zm0 23.34c-2.05 0-4.05-.55-5.8-1.6l-.42-.25-3.89 1.06 1.04-3.75-.27-.4a10.6 10.6 0 0 1-1.65-5.62C5.01 10.03 9.94 5.2 16 5.2s10.99 4.83 10.99 10.78S22.06 26.34 16 26.34Zm6.02-8.06c-.33-.16-1.94-.95-2.24-1.06-.3-.11-.52-.16-.74.16-.22.33-.85 1.06-1.04 1.28-.19.22-.38.25-.71.08-.33-.16-1.39-.51-2.65-1.64-.98-.88-1.64-1.96-1.83-2.29-.19-.33-.02-.5.14-.66.15-.15.33-.38.49-.57.16-.19.22-.33.33-.55.11-.22.05-.41-.03-.57-.08-.16-.74-1.78-1.02-2.44-.27-.65-.54-.56-.74-.57h-.63c-.22 0-.57.08-.87.41-.3.33-1.14 1.11-1.14 2.71s1.17 3.14 1.33 3.36c.16.22 2.3 3.52 5.58 4.94.78.34 1.39.54 1.87.69.79.25 1.5.21 2.06.13.63-.09 1.94-.79 2.21-1.55.27-.76.27-1.41.19-1.55-.08-.14-.3-.22-.63-.38Z"
          />

        </svg>

      </a>

    </section>
  );
}